// App version — bump the patch (.x) on each change; roll the minor (1.x.0) for a
// major change or when the patch hits .9.
export const APP_VERSION = "1.12.9";
